import Slideshow from './slideshow';

export default class SlideshowDesktop extends Slideshow {

    _containerNavPosition = {
        top: 0,
        left: 0
    };

    _componentSize = {
        width: 0,
        height: 0
    };

    constructor(...args) {
        super(...args);

    }
    _retrieveDOM(){
        super._retrieveDOM();

        if (this.fullscreen == "true") {
            this.dom.containerNav = this.dom.component.querySelector('.js-container-nav');
            this._getPosElements();
        }

    }
    bind() {
        super.bind();


    }

    _animate(){

        // Set height of slider bottom
        this._setHeight(this.params.next);

        // animation image
        this.animRounding.animate(this.params.next, this._containerNavPosition, this._componentSize);

        // animation text + border text
        let heightNextStep = this.dom.text[this.params.next].offsetHeight;

        if (this.fullscreen == "true") {


            this.animText.fromTo(this.dom.borderBottom[this.params.current], 0.5, {width: "100%"}, {width: 0, ease: Power3.easeInOut},0 )
                .fromTo(this.dom.text[this.params.current], 0.6, {autoAlpha: 1}, {autoAlpha: 0, force3D:true, ease: Power3.easeInOut}, 0.1 )
                .fromTo(this.dom.text[this.params.next], 0.6, {y: -heightNextStep, autoAlpha: 1}, {y: 0, force3D:true, ease: Power3.easeInOut}, 0.2 )
                .fromTo(this.dom.borderBottom[this.params.next], 0.5, {width: 0}, {width: "100%", ease: Power3.easeInOut}, 0.7 );

        }
        else {
            this.animText.fromTo(this.dom.text[this.params.current], 0.6, {autoAlpha: 1}, {autoAlpha: 0, force3D:true, ease: Power3.easeInOut}, 0 )
                .fromTo(this.dom.text[this.params.next], 0.6, {y: -heightNextStep, autoAlpha: 1}, {y: 0, force3D:true, ease: Power3.easeInOut}, 0.2 )
        }

    }
    _setSizeImg(){

        // for (let i = 0; i < this.dom.containerImages.length; i++) {
        //     let widthImg = this.dom.containerImages[i].offsetWidth;
        //     let heightImg = this.dom.containerImages[i].offsetHeight;
        //     let image = this.dom.containerImages[i].querySelector('.inner');
        //
        //     TweenLite.to(image,0 , {height: heightImg, width: widthImg, x: "-50%", y: "-50%"} );
        // }

    }

    resize(width, height) {
        super.resize(width, height);
        this._setSizeImg();

        if (this.fullscreen == "true")
            this._getPosElements();
    }

    _getPosElements() {
        this._componentSize = {
            top : this.dom.component.getBoundingClientRect().top,
            left : this.dom.component.getBoundingClientRect().left,
            width : this.dom.component.getBoundingClientRect().width,
            height : this.dom.component.getBoundingClientRect().height
        };

        if( this.dom.containerNav ) {
            this._containerNavPosition = {
                top : this.dom.containerNav.getBoundingClientRect().top + (this.dom.containerNav.getBoundingClientRect().height / 2),
                left : this.dom.containerNav.getBoundingClientRect().left + (this.dom.containerNav.getBoundingClientRect().width / 2)
            };
        }
    }


    /*
    init() {
    }

    unbind() {
    }
    resize(width, height) {
    }
    */
}




// WEBPACK FOOTER //
// src/js/components/slideshow/slideshow.desktop.js